import { Button, Col, Form, Input, Modal, Row, Select, Table, message } from 'antd';
import { useEffect, useState } from 'react';
import moment from 'moment';
import {
    PublicSoftware,
    getPubImageList,
    getPubSoftwareList,
    updateImageVersion,
    createImageVersion,
    getPubImageVersionDetail,
} from '@/services/api/bohrium';

const { Item } = Form;

export const ImageManager = () => {
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState<any>([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [form] = Form.useForm();
    const [addForm] = Form.useForm();
    const [curRow, setCurRow] = useState<PublicSoftware>();
    const [softwares, setSoftwares] = useState<PublicSoftware[]>([]);
    const [imageId, setImageId] = useState(0);

    const refresh = (newPage: number = page, newPageSize: number = pageSize, newImageId: number = imageId) => {
        const params = { ...form.getFieldsValue() };
        getPubImageList({ ...params, page: newPage, pageSize: newPageSize, imageId: newImageId }).then(rep => {
            setData(rep.data?.items || []);
            setTotal(rep.data?.total || 0);
            setPage(newPage ?? page);
            setPageSize(newPageSize ?? pageSize);
        });
    };
    const getVerisonDetail = (id: number) => {
        getPubImageVersionDetail(id).then(rep => {
            if (rep.code === 0) {
                rep.data.software = rep.data.software.join(',');
                addForm.setFieldsValue(rep.data);
            } else {
                message.error(rep.error?.msg || '服务器内部错误');
            }
        });
    };
    const getSoftwares = () => {
        getPubSoftwareList().then(rep => {
            setSoftwares(rep.data?.items || []);
        });
    };
    useEffect(() => {
        getSoftwares();
        refresh(page, pageSize, imageId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Row style={{ marginBottom: 8 }} justify="end">
                <Col span={12}>
                    <Form
                        form={form}
                        style={{
                            width: 300,
                        }}
                        labelCol={{
                            span: 5,
                        }}
                    >
                        <Item label="软件" name="image">
                            <Select
                                onChange={value => {
                                    setImageId(Number(value) || 0);
                                    refresh(page, pageSize, Number(value) || 0);
                                }}
                            >
                                {softwares.map(option => (
                                    <Select.Option key={option.id} value={option.id}>
                                        {option.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Item>
                    </Form>
                </Col>
                <Col span={12}>
                    <Button
                        style={{ marginLeft: 12 }}
                        onClick={() => {
                            setCurRow(undefined);
                            setVisible(true);
                        }}
                    >
                        添加
                    </Button>
                </Col>
            </Row>
            <Table
                pagination={{
                    defaultPageSize: pageSize,
                    current: page,
                    showSizeChanger: true,
                    onChange: (newPage: number, newPageSize?: number) => {
                        refresh(newPage, newPageSize);
                    },
                    total,
                }}
                dataSource={data}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                    },
                    {
                        title: '软件ID',
                        dataIndex: 'imageId',
                    },
                    {
                        title: '软件',
                        width: 150,
                        dataIndex: 'imageName',
                    },
                    {
                        title: 'lbgImageId',
                        dataIndex: 'lbgImageId',
                    },
                    {
                        title: '版本',
                        width: 150,
                        dataIndex: 'version',
                    },
                    {
                        title: '排序',
                        dataIndex: 'weight',
                    },
                    {
                        title: '添加时间',
                        dataIndex: 'createTime',
                        render: value => moment(value).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                        title: '修改时间',
                        dataIndex: 'updateTime',
                        render: value => moment(value).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                        title: '操作',
                        width: 100,
                        fixed: 'right',
                        render: (_, row) => (
                            <Button
                                style={{ marginRight: 4 }}
                                type="primary"
                                onClick={() => {
                                    setCurRow(row);
                                    getVerisonDetail(row.id);
                                    setVisible(true);
                                }}
                            >
                                编辑
                            </Button>
                        ),
                    },
                ]}
                scroll={{ x: true, y: 'calc(100vh - 230px)' }}
            />
            <Modal
                visible={visible}
                title={curRow?.id ? '编辑镜像' : '创建镜像'}
                onOk={async () => {
                    await addForm.validateFields();
                    const addFormValues = addForm.getFieldsValue();
                    const payload = {
                        ...addFormValues,
                    };

                    if (curRow?.id) {
                        updateImageVersion(payload, curRow.id).then(res => {
                            if (res.code === 0) {
                                message.success('更新成功');
                                addForm.resetFields();
                                setVisible(false);
                                refresh();
                            } else {
                                message.error(res.error?.msg || '服务器内部错误');
                            }
                        });
                    } else {
                        createImageVersion(payload).then(res => {
                            if (res.code === 0) {
                                message.success('添加成功');
                                addForm.resetFields();
                                setVisible(false);
                                refresh();
                            } else {
                                message.error(res.error?.msg || '服务器内部错误');
                            }
                        });
                    }
                }}
                onCancel={() => {
                    addForm.resetFields();
                    setVisible(false);
                }}
            >
                <Form
                    form={addForm}
                    labelCol={{
                        span: 5,
                    }}
                >
                    <Item label="软件" rules={[{ required: true, message: '请选择' }]} name="imageId">
                        <Select>
                            {softwares.map(option => (
                                <Select.Option key={option.id} value={option.id}>
                                    {option.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Item>
                    <Item
                        label="lbgImageID"
                        rules={[{ required: true, message: '请输入' }]}
                        name="lbgImageId"
                        getValueFromEvent={event => {
                            return Number(event.target.value);
                        }}
                    >
                        <Input type="number" />
                    </Item>
                    <Item label="版本" rules={[{ required: true, message: '请输入' }]} name="version">
                        <Input placeholder="请填写，限300字符" maxLength={300} />
                    </Item>
                    <Item label="包含软件包" rules={[{ required: true, message: '请输入' }]} name="software">
                        <Input.TextArea />
                    </Item>
                    <Item
                        label="排序"
                        name="weight"
                        getValueFromEvent={event => {
                            return Number(event.target.value);
                        }}
                    >
                        <Input type="number" placeholder="排序值相同，则按id倒排" />
                    </Item>
                    <Item label="可用资源" rules={[{ required: true, message: '请输入' }]} name="resourceType">
                        <Input defaultValue="CPU GPU" />
                    </Item>
                </Form>
            </Modal>
        </div>
    );
};
